import * as React from "react";

const ChevronLeft: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="7.41" height="12">
    <path d="M15.41 16.58 10.83 12l4.58-4.59L14 6l-6 6 6 6z" transform="translate(-8 -6)" style={{ fill: "#707070" }} />
  </svg>
);

export default ChevronLeft;
